// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"f2ecd84f","290":"8920961b","400":"dc9e7cda","716":"fc708e14"}[chunkId] + ".chunk.js";
};